export default {
	'Are you sure you want to restore all configurations to the default values?': 'すべての構成をデフォルト値に復元してもよろしいですか?',
	'Background color when hovering over the top bar': 'ホバー時のトップバーの背景色',
	'Background page switching animation': '背景ページ切り替えアニメーション',
	classic: 'クラシック',
	'Dark mode': 'ダークモード',
	default: 'デフォルト',
	'Double column': '二重列',
	'Exit full screen': '全画面表示を終了する',
	'Full screen is not supported': 'お使いのブラウザは全画面表示をサポートしていません。ブラウザを変更してもう一度お試しください~',
	'Layout configuration': 'レイアウト構成',
	'Layout mode': 'レイアウト',
	Login: 'ログイン',
	'Login to the buildadmin': 'BuildAdmin オープンソース コミュニティにログインします。',
	Logout: 'ログアウト',
	'Member center': 'メンバーセンター',
	'Member information': '会員情報',
	'overall situation': '全体的な状況',
	Password: 'パスワード',
	'Please enter buildadmin account name or email': 'BuildAdmin アカウント名/メールアドレス/携帯電話番号を入力してください',
	'Please enter the buildadmin account password': 'BuildAdmin アカウントのパスワードを入力してください',
	'Please select an animation name': 'アニメ名を選択してください',
	Profile: 'プロフィール',
	Register: 'アカウントがない方は登録へ',
	'Restore default': 'デフォルトに戻す',
	'Show side menu top bar (logo bar)': 'サイドメニューのトップバー（ロゴバー）を表示する',
	'Side menu accordion': 'サイドメニューアコーディオン',
	'Side menu active item background color': 'サイドメニューのアクティブ化項目の背景色',
	'Side menu active item text color': 'サイドメニューのアクティブ化項目のテキストの色',
	'Side menu bar background color': 'サイドメニューバーの背景色',
	'Side menu default icon': 'サイドメニューのデフォルトアイコン',
	'Side menu horizontal collapse': 'サイドメニューが水平方向に折りたたまれます',
	'Side menu text color': 'サイドメニューの文字色',
	'Side menu top bar background color': 'サイドメニューのトップバーの背景色',
	'Side menu width (when expanded)': 'サイドメニューの幅（展開時）',
	sidebar: 'サイドバー',
	'Single column': '単一列',
	'Top bar': 'トップバー',
	'Top bar background color': 'トップバーの背景色',
	'Top bar menu active item background color': 'トップバーメニューのアクティブ化項目の背景色',
	'Top bar menu active item text color': 'トップバーメニューのアクティブ化項目のテキストの色',
	'Top bar text color': 'トップバーのテキストの色',
	Username: 'ユーザー名',
}
